export function stringToDashFormat(str) {
  str = str.trim()
  return str.replace(/\s+/g, '-').toLowerCase()
}
